import { FC } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  InformationBox,
  MuiButtonTertiary,
  MuiGrid,
} from "../../../../components";
import { CreateProgramTemplateHeaderWrapper } from "./CreateProgramTemplateHeader.style";
import { useSiteCore } from "../../../../hooks/useSiteCore";

interface CreateProgramTemplateProps {
  allAccordionStatus: boolean;
  pageId: string;
  handleExpandCollapseAllChange: () => void;
  pageTitle: string;
  showExpandAll: boolean;
}

const getExpandIcon = (expanded: boolean) => {
  return expanded ? (
    <RemoveIcon color={"primary"} data-testid="remove-icon" />
  ) : (
    <AddIcon color={"primary"} data-testid="add-icon" />
  );
};

export const CreateProgramTemplateHeader: FC<CreateProgramTemplateProps> = ({
  allAccordionStatus,
  pageId,
  handleExpandCollapseAllChange,
  pageTitle,
  showExpandAll,
}) => {
  const { commonLabels } = useSiteCore();

  return (
    <CreateProgramTemplateHeaderWrapper>
      <InformationBox title={pageTitle} />
      {showExpandAll && (
        <MuiGrid className="header-collapse">
          <MuiButtonTertiary
            onClick={handleExpandCollapseAllChange}
            id={`${pageId}-expand`}
          >
            {allAccordionStatus
              ? commonLabels.collapseAll
              : commonLabels.expandAll}
            {getExpandIcon(allAccordionStatus)}
          </MuiButtonTertiary>
        </MuiGrid>
      )}
    </CreateProgramTemplateHeaderWrapper>
  );
};
